{
  "codeExpired": "El código ingresado ha expirado.",
  "codeInvalid": "El código que has introducido no es válido. Vuelve a comprobarlo y vuelve a intentarlo.",
  "decimalNumber": "Este campo debe ser un número.",
  "deviceLocationUnknown": "Ubicación del dispositivo desconocida.",
  "integerOnly": "Este campo debe ser un número entero.",
  "maxLengthWithVal": "Demasiados caracteres ({{val}} máximo)",
  "maxValueWithVal": "Este valor debe ser menor o igual a {{val}}.",
  "minLength": "Debe tener al menos {{minLength}} caracteres.",
  "minValueWithVal": "Este valor debe ser al menos {{val}}.",
  "passwordRulesLowercaseCount": "La contraseña debe contener al menos una letra minúscula.",
  "passwordRulesMinLength": "La contraseña debe tener al menos 8 caracteres.",
  "passwordRulesMustMatch": "Las contraseñas deben coincidir.",
  "passwordRulesNumericCount": "La contraseña debe contener al menos un número.",
  "passwordRulesSpecialCharacterCount": "La contraseña debe contener al menos un carácter especial (!@#$$^&*)",
  "passwordRulesUppercaseCount": "La contraseña debe contener al menos una letra mayúscula.",
  "required": "Este campo es obligatorio."
}
